import React, { useEffect, useRef, useState } from "react";
import { Button,Dialog, Paper,DialogTitle,DialogActions,DialogContent,CircularProgress ,Grid,Tooltip, Grow} from "@material-ui/core";
import styled from "styled-components";
import ApiClient from "utils/ApiClient";
import COLORS from "scss/colors.module.scss";
import * as mui from "@material-ui/icons";
import { snakeCase } from "lodash";
import Icon from "@material-ui/core/Icon";

function PackItems({packs,data,handleClose,setIsDuplicating,options, handleSheetOptionsMenuClose, dataRecordOptions}){
    const packStyleObject = () =>{ 
        return ({   width:100,
                    height:100,
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"space-between",
                    alignItems:"center",
                    color:"#237ff4",
                    backgroundColor: "#fafafa"
                    })}

    const handleOnClick = async (packId,sheetData) => {
        setIsDuplicating(true);
        await data.duplicateSheet(packId, sheetData, options, dataRecordOptions);
        handleClose();
        handleSheetOptionsMenuClose();
        setIsDuplicating(false);
    }
    
    return <AnotherStyledDiv>
        {packs.map(pack => <div key={pack.id}>
                  <Tooltip title={pack.name && pack.name} arrow={true}>
                      <Button onClick={()=>handleOnClick(pack.id,data.sheet)} >
                          <Paper style={packStyleObject()} > 
                                  {getIconForPacks(pack)}
                              <TitleDiv>
                                  <StyledSpan>{pack.name}</StyledSpan>
                              </TitleDiv>
                          </Paper> 
                      </Button>
                  </Tooltip>
                </div> )}
        </AnotherStyledDiv>;

}
    
function DuplicateSheetPacksMenu({open,data,handleClose,options, setCurrentPage, handleSheetOptionsMenuClose, dataRecordOptions}){

    const [packs,setPacks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inputString,setInputString] = useState("");
    const [isDuplicating, setIsDuplicating] = useState(false);
    const inputRef = useRef(null);

    const getPacks = async () => {
        setIsLoading(true);
        try{
            const resp = await ApiClient.Packs.getPacks();
            setIsLoading(false);
            let packs = resp.data.filter(pack => pack.name !== "History/Records" && +pack.is_log_pack != 1)
            setPacks(packs);
        }catch(e){
            setIsLoading(false);
            // give a something went wrong message
        }
    }

    useEffect(()=>{
        getPacks();
    },[]);

    const FilteredPacks = packs.filter(pack => pack.name.toLowerCase().includes(inputString.trim().toLowerCase()))

    const handlePreviousBtnClicked = () =>{
        setCurrentPage(1);
    }

    return (
        <Dialog onClose={handleClose} open={open} fullWidth={true} TransitionComponent={Grow} transitionDuration={1000}>
          <StyledDialogTitle>
            Which pack do you want to duplicate this sheet into?
            {!isLoading && !isDuplicating && (
              <StyledDiv>
                <StyledSearchBar
                  type="search"
                  placeholder="Search Packs"
                  value={inputString}
                  onChange={(e) => setInputString(e.target.value)}
                  disabled={isLoading}
                  ref={inputRef}
                />
              </StyledDiv>
            )}
          </StyledDialogTitle>
          <StyledDialogContent isDuplicating={isDuplicating}>
            {isLoading && !isDuplicating && <DummyDisplay />}
            {!isLoading && !isDuplicating && packs && packs.length > 0 && (
              <PackItems
                packs={FilteredPacks}
                data={data}
                handleClose={handleClose}
                setIsLoading={setIsLoading}
                options={options}
                setIsDuplicating={setIsDuplicating}
                handleSheetOptionsMenuClose={handleSheetOptionsMenuClose}
                dataRecordOptions={dataRecordOptions}
              />
            )}
            {isDuplicating && <DuplicationLoading />}
          </StyledDialogContent>
          <DialogActions>
            <StyledButton
              onClick={handlePreviousBtnClicked}
              variant="contained"
              color="primary"
              disabled={isLoading || isDuplicating}
            >
              PREVIOUS
            </StyledButton>
            <StyledButton
              onClick={() => {
                handleClose();
                handleSheetOptionsMenuClose();
            }}
              variant="outlined"
              color="primary"
              disabled={isLoading || isDuplicating}
            >
              CANCEL
            </StyledButton>
          </DialogActions>
        </Dialog>
      );
      
}

export default DuplicateSheetPacksMenu;

const StyledDialogContent = styled(DialogContent) `
    min-height:50vh;
    max-height: 69vh;
    background-color : #f2f2f2;
    height: ${({isDuplicating})=> isDuplicating ? "50vh" : "auto"};
    
`;

const StyledSearchBar = styled.input`
    width: 100%;
    border-radius: 90px;
    padding: 0.625rem;
    border: none;
    background-color : #f3f3f3;
    text-align: center;
    caret-color: blue;
    ::placeholder,
    ::-webkit-input-placeholder,
    ::-moz-placeholder{
        text-align:center;
    }
`;

const StyledDiv = styled.div`
    display: flex;
    justify-content: center;
    margin-inline: auto;
    margin-block-start: 0.625rem;
    
    
`;
const AnotherStyledDiv = styled.div`
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    gap: 1rem;
    height: 100%;
`;
const StyledDialogTitle = styled(DialogTitle)`
    text-align: center;
`
const StyledButton = styled(Button)`
    margin : 0.3rem 1rem;
`;

const IconStyled = styled(Icon)`
&& {
    height: 60px;
    width: 60px;
    text-align: center;
    color: ${(props) => props.themeColor ?? "rgba(0, 0, 0, 0.87)"};
    cursor: pointer;
    font-size: 60px;
    box-sizing: content-box;
    margin-block:auto;
    align-self: center;
}
`;

const TitleDiv = styled.div`
    width: 100%;
    display: grid;
    place-content: center;
    padding: 4px 3px;
    border-radius: 0 0 4px 4px;
    color: #000;
`;


const StyledSpan = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-inline: 4px;
    color: black; 
`;

function DummyDisplay(){
    const packs = [];
    for(let i=0;i<12;i++){
        packs.push({id:i+1});
    }
    return <AnotherStyledDiv>
        <Grid container spacing={2} justifyContent="space-evenly" alignItems="center" >
        {packs.map(pack => <Grid item xs={4} md={3} justifyContent="center" key={pack.id}>
        <Button className="dup-packs" disabled>
            <Paper style={{width:100,height:100,display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:"#454545"}} elevation={2}></Paper> 
            </Button>
            </Grid> )}
        </Grid>
    </AnotherStyledDiv>
}

const DuplicationLoading = () => {

    return <AnotherStyledDiv >
        <CircularProgress color="primary" size={26} />
        <span className="duplication-loading">Duplicating...</span>
    </AnotherStyledDiv>;
}
const getIconForPacks = (pack) => {
    let {icon: iconClasses} = pack;
    if (mui[iconClasses]) {
        iconClasses = snakeCase(iconClasses);
      }
    return (
        <IconStyled  themeColor={pack.color.trim() ||  "#237ff4"}>
          {iconClasses || "folder_open"}
        </IconStyled>
      );

}